import { useMemo } from "react";
import { useAuthState } from "react-firebase-hooks/auth";

import { auth } from "integrations/firebase/auth";
import {
  isRunningInMeticulous,
  METICULOUS_AUTH_USER,
} from "integrations/meticulous";

export const useAuthUser = () => {
  const [data, loading, error] = useAuthState(auth);

  return useMemo(() => {
    if (isRunningInMeticulous()) {
      return { data: METICULOUS_AUTH_USER, loading: false, error: undefined };
    }

    return { data, loading, error };
  }, [data, loading, error]);
};
